export const ADD_LOCAL_PARTY_MASTER_UPLOAD = 'ADD_LOCAL_PARTY_MASTER_UPLOAD'
export const ADD_LOCAL_PARTY_MASTER_UPLOAD_FAILURE = 'ADD_LOCAL_PARTY_MASTER_UPLOAD_FAILURE'
export const ADD_LOCAL_PARTY_MASTER_UPLOAD_SUCCESS = 'ADD_LOCAL_PARTY_MASTER_UPLOAD_SUCCESS'
export const ADD_LOCAL_PARTY_MASTER_UPLOAD_FAILURE_FILE = 'ADD_LOCAL_PARTY_MASTER_UPLOAD_FAILURE_FILE'

export const addLocalPartyMasterUpload = (data) => {
    return {
        type: ADD_LOCAL_PARTY_MASTER_UPLOAD,
        data
    }
}

export const addLocalPartyMasterUploadFailure  = (data) => {
    return {
        type: ADD_LOCAL_PARTY_MASTER_UPLOAD_FAILURE,
        data
    }
}

export const addLocalPartyMasterUploadFailureFile = (data) => {
    return {
        type: ADD_LOCAL_PARTY_MASTER_UPLOAD_FAILURE_FILE,
        data
    }
}

export const addLocalPartyMasterUploadSuccess = (data) => {
    return {
        type: ADD_LOCAL_PARTY_MASTER_UPLOAD_SUCCESS,
        data
    }
}

export const LOCAL_PARTY_MASTER_TEMPLATE_REQUEST = 'LOCAL_PARTY_MASTER_TEMPLATE_REQUEST';
export const LOCAL_PARTY_MASTER_TEMPLATE_SUCCESS = 'LOCAL_PARTY_MASTER_TEMPLATE_SUCCESS';
export const LOCAL_PARTY_MASTER_TEMPLATE_FAILURE = 'LOCAL_PARTY_MASTER_TEMPLATE_FAILURE';

export const localPartyMasterTemplateRequest = () => {
    return {
        type: LOCAL_PARTY_MASTER_TEMPLATE_REQUEST,
    }
}

export const localPartyMasterTemplateSuccess = (data) => {
    return {
        type: LOCAL_PARTY_MASTER_TEMPLATE_SUCCESS,
        data
    }
}

export const localPartyMasterTemplateFailure = (data) => {
    return {
        type: LOCAL_PARTY_MASTER_TEMPLATE_FAILURE,
        data
    }
}


export const LOCAL_PARTY_MASTER_DATA_EXCEL_SUCCESS = 'LOCAL_PARTY_MASTER_DATA_EXCEL_SUCCESS';
export const LOCAL_PARTY_MASTER_DATA_EXCEL_FAILURE = 'LOCAL_PARTY_MASTER_DATA_EXCEL_FAILURE';
export const LOCAL_PARTY_MASTER_DATA_EXCEL_REQUEST = 'LOCAL_PARTY_MASTER_DATA_EXCEL_REQUEST';

export const localPartyMasterDataExcelRequest = () => {
    return {
        type: LOCAL_PARTY_MASTER_DATA_EXCEL_REQUEST,
    }
}

export const localPartyMasterDataExcelSuccess = (data) => {
    return {
        type: LOCAL_PARTY_MASTER_DATA_EXCEL_SUCCESS,
        data
    }
}

export const localPartyMasterDataExcelFailure = (data) => {
    return {
        type: LOCAL_PARTY_MASTER_DATA_EXCEL_FAILURE,
        data
    }
}

export const LOCAL_PARTY_MASTER_LIST_REQUEST = 'LOCAL_PARTY_MASTER_LIST_REQUEST';
export const LOCAL_PARTY_MASTER_LIST_SUCCESS = 'LOCAL_PARTY_MASTER_LIST_SUCCESS';
export const LOCAL_PARTY_MASTER_LIST_FAILURE = 'LOCAL_PARTY_MASTER_LIST_FAILURE';

export const localPartyMasterListRequest = (data) => ({
  type: LOCAL_PARTY_MASTER_LIST_REQUEST,
  data
});

export const localPartyMasterListSuccess = (data) => ({
  type: LOCAL_PARTY_MASTER_LIST_SUCCESS,
  data
});

export const localPartyMasterListFailure = (data) => ({
  type: LOCAL_PARTY_MASTER_LIST_FAILURE,
  data
});